export class DeviceModel {
  constructor(
    id,
    deviceCode,
    brand,
    model,
    batteryHealth = null,
    batteryStatus = null,
    online = null,
    dtInicio = null,
    dtFim = null,
    lastBatteryAt = null
  ) {
    this.id = id;
    this.deviceCode = deviceCode;
    this.brand = brand;
    this.model = model;
    this.batteryHealth = batteryHealth;
    this.batteryStatus = batteryStatus;
    this.online = online;
    this.dtInicio = dtInicio;
    this.dtFim = dtFim;
    this.lastBatteryAt = lastBatteryAt;
  }

  toJson() {
    return JSON.stringify({
      id: this.id,
      deviceCode: this.deviceCode,
      brand: this.brand,
      model: this.model,
      batteryHealth: this.batteryHealth,
      batteryStatus: this.batteryStatus,
      online: this.online,
      dtInicio: this.dtInicio,
      dtFim: this.dtFim,
      lastBatteryAt: this.lastBatteryAt,
    });
  }

  /**
   * Para listagem básica - sem detalhes
   */
  static fromJson(json) {
    return new DeviceModel(
      json.id,
      json.dispositivo_cod,
      json.marca,
      json.modelo,
      null,
      null,
      null,
      null,
      null,
      json.ultima_bateria_em
    );
  }

  /**
   * Para detalhes completos
   */
  static fromJsonDetalhes(json) {
    return new DeviceModel(
      json.id,
      json.dispositivo_cod,
      json.marca,
      json.modelo,
      json.bateriaSaude_nome,
      json.bateriaStatus_nome,
      json.online ?? false,
      json.dtInicio,
      json.dtFim
    );
  }
}
